// React Dependencies
import React, { Suspense, useState } from 'react';
import loadable from '@loadable/component';
// Common Dependencies
import { Routes, Route } from 'react-router-dom';
import PropTypes from 'prop-types';

import { useRouteAccessList } from '@hooks';

// Components
import DatabaseRoutes from '../Database/DatabaseRoute';
import DatabaseTableRoutes from '../DatabaseTable/DatabaseTableRoute';
import TableColumnRoutes from '../TableColumn/TableColumnRoute';
import TeamMemberRoutes from '../Teams/TeamMemberRoute';
import TaskStatusTypeRoutes from '../TaskStatusType/TaskStatusTypeRoute';
import SprintRoutes from '../Sprints/SprintRoute';
import TaskRoutes from '../Task/TaskRoute';
import ActivityRoute from '../Activity/ActivityRoute';
import { Loader } from '../../../../common/components';
// import { ProjectNavigation } from '../Navigation/ProjectNavigation';
import ListShimmer from '../../PageShimmers/ListShimmer';
// Routes
const ListProjectPage = loadable(() => import('./ListProjectPage'), {
  fallback: <Loader />
});
const ProjectNavigation = loadable(() => import('../Navigation/ProjectNavigation'), {
  fallback: <Loader />
});
const AddProjectPage = loadable(() => import('./AddProjectPage'), {
  fallback: <Loader />
});
const EditProjectPage = loadable(() => import('./EditProjectPage'), {
  fallback: <Loader />
});
const ViewProjectPage = loadable(() => import('./ViewProjectPage'), {
  fallback: <Loader />
});

const ProjectRoute = ({ t, alert }) => {
  const [routeName, setRouteNames] = useState([]);
  const [tabLoading, setTabLoading] = useState(true);
  // Route Access List
  useRouteAccessList((res) => {
    setRouteNames(res.data.route_name);
  });

  return (
    <Routes key={'routes'}>
      <Route
        key={'project_list'}
        index
        exact
        path="/list"
        element={<ListProjectPage t={t} alert={alert} />}
      />
      {/* <Route
        key={'project_list'}
        exact
        path="/list"
        element={
          <Suspense fallback={<ListShimmer />}>
            <ListProjectPage t={t} />
          </Suspense>
        }
      /> */}
      <Route
        key={'project_add'}
        exact
        path="/add"
        element={<AddProjectPage t={t} alert={alert} />}
      />
      <Route
        key={'project_edit'}
        exact
        path="/edit/:projectId"
        element={<EditProjectPage t={t} alert={alert} />}
      />
      <Route
        path="/"
        element={
          <ProjectNavigation t={t} routeName={routeName} tabLoading={tabLoading} alert={alert} />
        }>
        <Route
          key={'project_view'}
          exact
          path="/view/details/:projectId"
          element={<ViewProjectPage t={t} alert={alert} />}
        />
        {/* Include DatabaseRoutes */}
        {DatabaseRoutes({ t, setTabLoading, alert })}
        {/* Include DatabaseTableRoutes */}
        {DatabaseTableRoutes({ t, setTabLoading, alert })}
        {/* Include TableColumnRoutes */}
        {TableColumnRoutes({ t, setTabLoading, alert })}
        {TeamMemberRoutes({ t, setTabLoading, alert })}
        {TaskStatusTypeRoutes({ t, setTabLoading, alert })}
        {SprintRoutes({ t, setTabLoading, alert })}
        {TaskRoutes({ t, setTabLoading, alert })}
        {ActivityRoute({ t, setTabLoading })}
      </Route>
    </Routes>
  );
};
ProjectRoute.propTypes = {
  t: PropTypes.func
};
export default ProjectRoute;
